const styles = (theme) => ({
  cardContent: {
    width: '100%',
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    padding: `0 ${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme
      .spacing.unit * 2}px`,
    [theme.breakpoints.up('md')]: {
      padding: `0 ${theme.spacing.unit * 6}px ${theme.spacing.unit *
        3}px 112px`,
    },
  },
  cardContentNoIndent: {
    [theme.breakpoints.up('md')]: {
      paddingRight: theme.spacing.unit * 3,
      paddingLeft: theme.spacing.unit * 3,
    },
  },
  cardContentAction: {
    padding: `0 ${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px 104px`,
    [theme.breakpoints.up('md')]: {
      paddingLeft: 112,
      paddingRight: theme.spacing.unit * 6,
    },
  },
  helpText: {
    marginTop: theme.spacing.unit,
  },
});

export default styles;
